(function () {
  'use strict';

  function setSlide(slider, index) {
    var slides = slider.querySelectorAll('.bh-product-slide');
    var dots = slider.querySelectorAll('.bh-product-dot');

    index = Math.max(0, Math.min(index, slides.length - 1));

    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });

    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });

    slider.dataset.bhCurrentSlide = index;
  }

  function initSlider(slider) {

    slider.addEventListener('touchstart', function () {
  slider.classList.add('is-touching');
}, { passive: true });

slider.addEventListener('touchend', function () {
  setTimeout(function () {
    slider.classList.remove('is-touching');
  }, 800);
}, { passive: true });

    if (slider.dataset.bhSliderInit === '1') return;

    slider.dataset.bhSliderInit = '1';

    var slides = slider.querySelectorAll('.bh-product-slide');

    if (slides.length < 2) return;

    setSlide(slider, 0);

    /* Desktop hover */
    slider.addEventListener('mousemove', function (event) {
      if (window.innerWidth <= 589) return;

      var rect = slider.getBoundingClientRect();
      var position = event.clientX - rect.left;
      var index = Math.floor((position / rect.width) * slides.length);

      setSlide(slider, index);
    });

    slider.addEventListener('mouseleave', function () {
      if (window.innerWidth > 589) {
        setSlide(slider, 0);
      }
    });

    /* Mobile swipe */
    var startX = 0;
    var startY = 0;

    slider.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    slider.addEventListener('touchend', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;

      var endX = event.changedTouches[0].clientX;
      var endY = event.changedTouches[0].clientY;

      var dx = endX - startX;
      var dy = endY - startY;

      /* Ignore vertical page scrolling */
      if (Math.abs(dx) < 35 || Math.abs(dx) <= Math.abs(dy)) return;

      var current = parseInt(slider.dataset.bhCurrentSlide || '0', 10);

      if (dx < 0) {
        setSlide(slider, current + 1);
      } else {
        setSlide(slider, current - 1);
      }
    }, { passive: true });
  }

  function initAll() {
    document
      .querySelectorAll('.bh-product-slider')
      .forEach(initSlider);
  }

  initAll();

  var grid = document.getElementById('productGrid');

  if (grid) {
    new MutationObserver(function () {
      initAll();
    }).observe(grid, {
      childList: true
    });
  }
})();